import { jsx, jsxs } from "react/jsx-runtime";
import FormControl from "@mui/material/FormControl";
import classnames from "classnames";
import { Typography } from "../../Typography/index.js";
import { Box } from "../../Box/index.js";
import { RadioInput } from "../index.js";
import { Label } from "../common/index.js";
import MultipleRadioInput_styles from "./MultipleRadioInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleRadioInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleRadioInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const MultipleRadioInput = (_0)=>{
    let { disabled = false, values, label, labelIcon, tooltip = null, groupValue, options, trueLabel, falseLabel, neverLabel, allTrueLabel = `Везде ${trueLabel.toLowerCase()}`, allFalseLabel = `Везде ${falseLabel.toLowerCase()}`, allNeverLabel = `Не согласует ${null == neverLabel ? void 0 : neverLabel.toLowerCase()}`, allSplitLabel = 'Ручной выбор', onChangeForAllElements, onChangeForElement, required = false, withoutGroup = false } = _0, rest = _object_without_properties(_0, [
        "disabled",
        "values",
        "label",
        "labelIcon",
        "tooltip",
        "groupValue",
        "options",
        "trueLabel",
        "falseLabel",
        "neverLabel",
        "allTrueLabel",
        "allFalseLabel",
        "allNeverLabel",
        "allSplitLabel",
        "onChangeForAllElements",
        "onChangeForElement",
        "required",
        "withoutGroup"
    ]);
    const { classes } = MultipleRadioInput_styles();
    return /*#__PURE__*/ jsxs(FormControl, {
        className: classnames(classes.multipleRadioInput, 'aqa_multiple_radion_input'),
        children: [
            label && /*#__PURE__*/ jsx(Label, {
                label: label,
                tooltip: tooltip,
                required: required,
                icon: labelIcon
            }),
            !withoutGroup && /*#__PURE__*/ jsx(Box, {
                pb: "20",
                children: /*#__PURE__*/ jsx(RadioInput, _object_spread_props(_object_spread({}, rest), {
                    row: true,
                    value: groupValue,
                    disabled: disabled,
                    items: [
                        {
                            label: allTrueLabel,
                            value: 'all'
                        },
                        {
                            label: allFalseLabel,
                            value: 'none'
                        },
                        ...neverLabel ? [
                            {
                                label: allNeverLabel,
                                value: 'never'
                            }
                        ] : [],
                        {
                            label: allSplitLabel,
                            value: 'hand'
                        }
                    ],
                    onChange: onChangeForAllElements
                }))
            }),
            /*#__PURE__*/ jsx(Box, {
                border: 1,
                borderColor: "stroke.primary",
                radius: "l",
                px: "16",
                children: options.map(({ id, label: optionLabel, disabled: disabledOption }, index)=>{
                    var _values_find;
                    return /*#__PURE__*/ jsxs(Box, {
                        py: "8",
                        borderTop: 0,
                        borderRight: 0,
                        borderLeft: 0,
                        borderBottom: index === options.length - 1 ? 0 : 1,
                        borderColor: "stroke.primary",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "24",
                        children: [
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "body2",
                                children: optionLabel
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                flexShrink: 0,
                                py: "8",
                                children: /*#__PURE__*/ jsx(RadioInput, _object_spread_props(_object_spread({}, rest), {
                                    row: true,
                                    disabled: disabled || disabledOption,
                                    value: String(values ? (null == (_values_find = values.find((opt)=>opt.id === id)) ? void 0 : _values_find.value) || false : false),
                                    items: [
                                        {
                                            label: trueLabel,
                                            value: 'always'
                                        },
                                        {
                                            label: falseLabel,
                                            value: 'direct_only'
                                        },
                                        ...neverLabel ? [
                                            {
                                                label: neverLabel,
                                                value: 'never'
                                            }
                                        ] : []
                                    ],
                                    onChange: onChangeForElement(id)
                                }))
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};
export { MultipleRadioInput };
